/**
 * QualityPage - Container for Quality department features
 * 
 * Routes between:
 * - NDE Tracker (global view)
 * - Welder Continuity Log
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import WelderContinuityLog from './WelderContinuityLog';
import ProcessLog from './ProcessLog';

const QualityPage = () => {
  const location = useLocation();
  const menuItem = location.state?.menuItem || 'quality-welder-continuity-log';

  const renderContent = () => {
    switch (menuItem) {
      case 'quality-process-log':
        return <ProcessLog />;
      case 'quality-welder-continuity-log':
      default:
        return <WelderContinuityLog />;
    }
  };

  return renderContent();
};

export default QualityPage;
